import React, { useEffect, useRef } from "react";
import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { testRoomSnState } from "recoil/auth";
import useExamRoomActions from "../../../../api/hooks/admin/examRoom";
import {
  hourOptions,
  minuteOptions,
  questionOption,
  speakLanguageOption,
} from "../../../../static";
import Select from "../../../atoms/input/Select";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";
import { SERVER_IP } from "../../../../static/server";
// 관리자-시험실-시험실설정탭

const exerciseQuestion = (getExerciseList, setExerciseList, isTestRoomSn) => {
  if (getExerciseList?.data === undefined) {
    console.log("리턴됨2");
    return;
  }

  const state1 = () => {
    document.getElementById("existingQuestionDiv0").style.display = "";
    document.getElementById("existingQuestionDiv1").style.display = "none";
    document.getElementById("existingQuestionDiv2").style.display = "";

    document.getElementById("existingQuestionSecondDiv1").style.display =
      "none";
    document.getElementById("existingQuestionSecondDiv2").style.display =
      "none";
    document.getElementById("existingQuestionSecondDiv3").style.display =
      "none";
    document.getElementById("existingQuestionSecondInput1").style.display = "";
    document.getElementById("existingQuestionSecondInput2").style.display = "";
    document.getElementById("existingQuestionSecondInput3").style.display = "";
  };
  const state2 = () => {
    document.getElementById("existingQuestionDiv0").style.display = "none";
    document.getElementById("existingQuestionDiv1").style.display = "";
    document.getElementById("existingQuestionDiv2").style.display = "none";

    document.getElementById("existingQuestionSecondDiv1").style.display = "";
    document.getElementById("existingQuestionSecondDiv2").style.display = "";
    document.getElementById("existingQuestionSecondDiv3").style.display = "";
    document.getElementById("existingQuestionSecondInput1").style.display =
      "none";
    document.getElementById("existingQuestionSecondInput2").style.display =
      "none";
    document.getElementById("existingQuestionSecondInput3").style.display =
      "none";
  };

  const existingQuestion = () => {
    return (
      <tr>
        <td>1</td>
        <td className="text-align-left width-742">
          <input
            type="text"
            className="q-insert-input motto-input mb-10"
            placeholder={getExerciseList?.data?.data?.text}
            defaultValue={getExerciseList?.data?.data?.text}
            id="existingQuestionInput"
          />
          <br />
          <div id="existingQuestionDiv0" style={{ display: "none" }}>
            <div
              className="dropdown question-dropdown-lang mb-10"
              id="existingQuestionSelect"
            >
              <Select options={speakLanguageOption} />
            </div>
            <button
              id="existingQuestionInputChangeButton"
              type="button"
              className="q-insert-btn create-btn"
              onClick={() => {
                var selectedLanguage = document.getElementById(
                  "existingQuestionSelect"
                ).childNodes[0].childNodes[0];
                selectedLanguage =
                  selectedLanguage.options[selectedLanguage.selectedIndex].text;
                var toEnglishLanguage = "en";
                if (selectedLanguage === "한국어") {
                  toEnglishLanguage = "ko";
                }
                setExerciseList.mutate({
                  testroom_sn: isTestRoomSn,
                  text: document.getElementById("existingQuestionInput").value,
                  language: toEnglishLanguage,
                });
                state2();
              }}
            >
              음성파일생성
            </button>
            <br />
          </div>

          <button
            type="button"
            className="q-insert-btn listen"
            onClick={() => {
              document.getElementById("existingQuestionAudio").play();
            }}
          >
            음성듣기
          </button>
          <audio controls="controls" id="existingQuestionAudio">
            <source
              src={SERVER_IP + getExerciseList?.data?.data?.url}
              type="audio/ogg"
            />
          </audio>
        </td>
        <td>
          <img
            className="icon-camera"
            src="../img/icon_camera.svg"
            alt="응답유형"
          />
        </td>
        <td>
          <div id="existingQuestionSecondDiv1">3초</div>
          <div id="existingQuestionSecondInput1" style={{ display: "none" }}>
            <input type="number" className="q-insert-input num-input" />
          </div>
        </td>
        <td>
          <div id="existingQuestionSecondDiv2">3초</div>
          <div id="existingQuestionSecondInput2" style={{ display: "none" }}>
            <input type="number" className="q-insert-input num-input" />
          </div>
        </td>
        <td>
          <div id="existingQuestionSecondDiv3">3초</div>
          <div id="existingQuestionSecondInput3" style={{ display: "none" }}>
            <input type="number" className="q-insert-input num-input" />
          </div>
        </td>

        <td>
          <div id="existingQuestionDiv1">
            <button
              type="button"
              className="insert-modalbtn"
              onClick={() => {
                state1();
              }}
            ></button>
          </div>
          <div id="existingQuestionDiv2" style={{ display: "none" }}>
            <button
              className="modify-btn"
              onClick={() => {
                state2();
                document
                  .getElementById("existingQuestionInputChangeButton")
                  .click();
              }}
            >
              수정
            </button>
          </div>
        </td>
      </tr>
    );
  };

  return (
    <div className="roomtable-content7-sec">
      <div className="flex mb-10">
        <p style={{ fontWeight: 700 }}>연습문항</p>
      </div>
      <div className="tableFixHead table-responsive" style={{ maxHeight: 530 }}>
        <table className="roomtable-content7-1 modify-table">
          <tbody>
            <tr>
              <th>No.</th>
              <th>문항</th>
              <th>응답유형</th>
              <th>준비시간</th>
              <th>최소응답</th>
              <th>최대응답</th>
              <th>작업</th>
            </tr>
            {existingQuestion()}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const VoiceGuide = (props) => {
  const setVoiceGuideAudioNumber = props.setVoiceGuideAudioNumber;
  if (props.getGuidanceList === undefined) {
    console.log("리턴됨");
    return;
  }
  let voiceGuideFile = [
    {
      title: "개인정보제공 동의",
      url: SERVER_IP + props?.getGuidanceList["guide_personal_info_voice_url"],
      keydata: "guide_personal_info_voice_url",
    },
    {
      title: "진행가이드",
      url: SERVER_IP + props?.getGuidanceList["guide_progress_info_voice_url"],
      keydata: "guide_progress_info_voice_url",
    },
    {
      title: "면접 응시 안내",
      url: SERVER_IP + props?.getGuidanceList["guide_test_info_voice_url"],
      keydata: "guide_test_info_voice_url",
    },
    {
      title: "웹캠/마이크 설정",
      url: SERVER_IP + props?.getGuidanceList["guide_webcam_info_voice_url"],
      keydata: "guide_webcam_info_voice_url",
    },
    {
      title: "연습문제(녹화 전)",
      url: SERVER_IP + props?.getGuidanceList["guide_prerecord_info_voice_url"],
      keydata: "guide_prerecord_info_voice_url",
    },
    {
      title: "연습문제(녹화 후)",
      url:
        SERVER_IP + props?.getGuidanceList["guide_afterrecord_info_voice_url"],
      keydata: "guide_afterrecord_info_voice_url",
    },
    {
      title: "종료화면",
      url: SERVER_IP + props?.getGuidanceList["guide_done_info_voice_url"],
      keydata: "guide_done_info_voice_url",
    },
  ];

  const transmissionSound = (e, i, keydata) => {
    try {
      var filename = e.target.files[0].name.split(".")[1];
      if (filename === "mp3" || filename === "wav") {
        document.getElementById("voiceGuideFileName" + i).value =
          e.target.files[0].name;
        props.setGuidanceList.mutate({
          testroom_sn: props.isTestRoomSn,
          type: keydata,
          file: e.target.files[0],
        });
        setVoiceGuideAudioNumber(i);
        return true;
      }
      return false;
    } catch (err) {}
    return false;
  };

  return voiceGuideFile?.map((item, i) => {
    return (
      <tr key={i}>
        <td>{i + 1}</td>
        <td>{item.title}</td>
        <td className="width-534 text-align-left">
          <audio
            id={"voiceGuideAudio" + i}
            controls="controls"
            className="mb-10"
          >
            <source src={item.url} type="audio/ogg" />
          </audio>
          <div id={"voiceGuideFile" + i} style={{ display: "none" }}>
            <label
              htmlFor={"voiceGuideUploadBtn" + i}
              className="file-select-btn"
            >
              파일선택
            </label>
            <input
              type="text"
              className="file-select-input"
              id={"voiceGuideFileName" + i}
              disabled="disabled"
              placeholder="선택된 파일 없음"
            />
            <input
              type="file"
              id={"voiceGuideUploadBtn" + i}
              name={"voiceGuideUploadBtn" + i}
              className="uploadBtn"
              style={{ display: "none" }}
              onChange={(e) => {
                transmissionSound(e, i, item.keydata);
              }}
            />
          </div>
        </td>
        <td>
          <label className="switch">
            <input type="checkbox" />
            <span className="slider-switch round"></span>
          </label>
        </td>
        <td>
          <button
            id={"voiceGuidePencilButton" + i}
            type="button"
            className="insert-modalbtn"
            onClick={(e) => {
              document.getElementById("voiceGuideUploadBtn" + i).click();
            }}
          ></button>
          <button className="trashbtn"></button>
        </td>
      </tr>
    );
  });
};

const timeConverter = (time) => {
  if (time.length === 1) return `0${time}`;
  return time;
};

const YYYYMMDDHHmm = (date, hour, minute) => {
  return `${date.split("-").join("")}${timeConverter(hour)}${timeConverter(
    minute
  )}`;
};

const Settings = () => {
  const isTestRoomSn = useRecoilValue(testRoomSnState);
  const queryClient = useQueryClient();
  const { getTestRoomInfo } = useExamRoomActions();
  const { setTestRoomInfo } = useExamRoomActions();
  const { getExercise } = useExamRoomActions();
  const { setExercise } = useExamRoomActions();
  const { getGuidance } = useExamRoomActions();
  const { setGuidance } = useExamRoomActions();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  // 접수 url 응시 url
  const [receiptUrl, setReceiptUrl] = useState("");
  const [applyUrl, setapplytUrl] = useState("");
  // 파일 업로드 placeholder
  const [filename, setFilename] = useState("선택된 파일 없음");
  // 연습문항 바뀔때 useEffect 처리를 위한 변수
  const [exerciseChanged, setExerciseChanged] = useState(0);
  // 음성안내 파일 바꾼 오디오 번호 저장
  const [voiceGuideAudioNumber, setVoiceGuideAudioNumber] = useState("");
  const [voiceGuideAudioNumberChanged, setVoiceGuideAudioNumberChanged] =
    useState(0);

  // 시험실설정 API
  const { data: ExamResultList } = useQuery({
    queryKey: ["getTestRoomInfo", isTestRoomSn],
    queryFn: () => getTestRoomInfo({ room_sn: isTestRoomSn }),
    staleTime: Infinity,
  });
  const setExamResultList = useMutation(setTestRoomInfo, {
    onSuccess: (context) => {
      queryClient.invalidateQueries(["getTestRoomInfo"]);
      alert("저장 완료");
    },
    onError: () => {},
  });

  // // 연습문항 API
  // const { data: getExerciseList } = useQuery({
  //   queryKey: ["getExercise", isTestRoomSn],
  //   queryFn: () => getExercise({ testroom_sn: isTestRoomSn }),
  //   staleTime: Infinity,
  // });
  // const setExerciseList = useMutation(setExercise, {
  //   onSuccess: (context) => {
  //     queryClient.invalidateQueries(["getExercise"]);
  //     setExerciseChanged(exerciseChanged + 1);
  //   },
  //   onError: () => {},
  // });
  // useEffect(() => {
  //   setTimeout(() => {
  //     try {
  //       var voiceGuideAudio = document.getElementById("existingQuestionAudio");
  //       voiceGuideAudio.pause();
  //       voiceGuideAudio.load();
  //       // voiceGuideAudio.play();
  //     } catch {}
  //   }, 1000);
  // }, [exerciseChanged]);

  // // 음성안내 파일 API
  // const { data: getGuidanceList } = useQuery({
  //   queryKey: ["getGuidance", isTestRoomSn],
  //   queryFn: () => getGuidance({ testroom_sn: isTestRoomSn }),
  //   staleTime: Infinity,
  // });
  // const setGuidanceList = useMutation(setGuidance, {
  //   onSuccess: (context) => {
  //     queryClient.invalidateQueries(["getGuidance"]);
  //     setVoiceGuideAudioNumberChanged(voiceGuideAudioNumberChanged + 1);
  //   },
  //   onError: () => {
  //     alert("음성안내 파일 업로드 실패");
  //   },
  // });
  useEffect(() => {
    setTimeout(() => {
      try {
        var voiceGuideAudio = document.getElementById(
          "voiceGuideAudio" + voiceGuideAudioNumber
        );
        voiceGuideAudio.pause();
        voiceGuideAudio.load();
        // voiceGuideAudio.play();
      } catch {}
    }, 1000);
  }, [voiceGuideAudioNumberChanged]);

  // console.log("api로 받아온 값");
  // console.log(ExamResultList?.data);
  // console.log(getExerciseList?.data?);
  // console.log(getGuidanceList?.data?);

  const onSubmit = (data) => {
    const removeDash = (YYYYMMDD) => {
      return YYYYMMDD.replace(/\-/g, "");
    };
    const addZero = (HHmm) => {
      if (HHmm < 10) {
        return "0" + HHmm;
      } else return HHmm;
    };

    // console.log("data", data);
    // console.log(document.getElementById("uploadBtn").files[0]);
    // 진짜로 정보를 보내는 부분
    setExamResultList.mutate({
      room_sn: isTestRoomSn,
      room_type: parseInt(data.room_type),
      group_title: data.group_title,
      titleText: data.title,
      regist_period_starttime: String(
        removeDash(data.regist_starttime_YYYYMMDD) +
          addZero(data.regist_starttime_HH) +
          addZero(data.regist_starttime_mm)
      ),
      regist_period_endtime: String(
        removeDash(data.regist_endtime_YYYYMMDD) +
          addZero(data.regist_endtime_HH) +
          addZero(data.regist_endtime_mm)
      ),
      test_period_starttime: String(
        removeDash(data.test_starttime_YYYYMMDD) +
          addZero(data.test_starttime_HH) +
          addZero(data.test_starttime_mm)
      ),
      test_period_endtime: String(
        removeDash(data.test_endtime_YYYYMMDD) +
          addZero(data.test_endtime_HH) +
          addZero(data.test_endtime_mm)
      ),
      file: document.getElementById("uploadBtn").files[0],
    });
  };

  useEffect(() => {
    reset({
      group_title: ExamResultList?.data["group_title"],
      title: ExamResultList?.data["title"],

      // 신청 시작일시, 종료일시
      regist_starttime_YYYYMMDD: dayjs(
        ExamResultList?.data["regist_period_starttime"]
      ).format("YYYY-MM-DD"),
      regist_starttime_HH: parseInt(
        dayjs(ExamResultList?.data["regist_period_starttime"]).format("HH")
      ),
      regist_starttime_mm: parseInt(
        dayjs(ExamResultList?.data["regist_period_starttime"]).format("mm")
      ),
      regist_endtime_YYYYMMDD: dayjs(
        ExamResultList?.data["regist_period_endtime"]
      ).format("YYYY-MM-DD"),
      regist_endtime_HH: parseInt(
        dayjs(ExamResultList?.data["regist_period_endtime"]).format("HH")
      ),
      regist_endtime_mm: parseInt(
        dayjs(ExamResultList?.data["regist_period_endtime"]).format("mm")
      ),

      // 응시 시작일시, 종료일시
      test_starttime_YYYYMMDD: dayjs(
        ExamResultList?.data["test_period_starttime"]
      ).format("YYYY-MM-DD"),
      test_starttime_HH: parseInt(
        dayjs(ExamResultList?.data["test_period_starttime"]).format("HH")
      ),
      test_starttime_mm: parseInt(
        dayjs(ExamResultList?.data["test_period_starttime"]).format("mm")
      ),
      test_endtime_YYYYMMDD: dayjs(
        ExamResultList?.data["test_period_endtime"]
      ).format("YYYY-MM-DD"),
      test_endtime_HH: parseInt(
        dayjs(ExamResultList?.data["test_period_endtime"]).format("HH")
      ),
      test_endtime_mm: parseInt(
        dayjs(ExamResultList?.data["test_period_endtime"]).format("mm")
      ),

      send_regist_start: YYYYMMDDHHmm(
        dayjs(ExamResultList?.data["regist_period_starttime"]).format(
          "YYYY-MM-DD"
        ),
        dayjs(ExamResultList?.data["regist_period_starttime"]).format("HH"),
        dayjs(ExamResultList?.data["regist_period_starttime"]).format("mm")
      ),

      room_type: ExamResultList?.data["room_type"],
      language: ExamResultList?.data["language"],
    });

    setReceiptUrl(SERVER_IP + "/receipt/" + ExamResultList?.data["group_uuid"]);
    setapplytUrl(SERVER_IP + "/apply/" + ExamResultList?.data["group_uuid"]);
  }, [ExamResultList]);

  return (
    <div
      className="tab-pane fade tab-content"
      id="content7"
      role="tabpanel"
      aria-labelledby="tab7"
    >
      <div className="tab-title">
        <p>시험실설정</p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="plus-box-div">
          <div className="plus-box">
            <span className="plus-title">그룹이름</span>
            <input
              type="text"
              className="plus-title-input"
              style={{ width: "800px" }}
              {...register("group_title", { required: true })}
            />
          </div>
          <div className="plus-box">
            <span className="plus-title">제목</span>
            <input
              type="text"
              className="plus-title-input"
              style={{ width: "800px" }}
              {...register("title")}
            />
          </div>
          <div className="plus-box">
            <span className="plus-title">신청기간</span>
            <div className="period-box">
              <span className="date-period start-period">시작일시</span>

              <div className="dropdown period-dropdown">
                <input
                  type="date"
                  className="period-input"
                  {...register("regist_starttime_YYYYMMDD", {
                    required: true,
                  })}
                />
                <Select
                  options={hourOptions}
                  refs={{
                    ...register("regist_starttime_HH", { required: true }),
                  }}
                />
                <Select
                  options={minuteOptions}
                  refs={{
                    ...register("regist_starttime_mm", { required: true }),
                  }}
                />
              </div>

              <span className="date-period end-period">종료일시</span>

              <div className="dropdown period-dropdown">
                <input
                  type="date"
                  className="period-input"
                  {...register("regist_endtime_YYYYMMDD", {
                    required: true,
                  })}
                />
                <Select
                  options={hourOptions}
                  refs={{
                    ...register("regist_endtime_HH", { required: true }),
                  }}
                />
                <Select
                  options={minuteOptions}
                  refs={{
                    ...register("regist_endtime_mm", { required: true }),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="plus-box">
            <span className="plus-title">응시기간</span>
            <div className="period-box">
              <span className="date-period start-period">시작일시</span>

              <div className="dropdown period-dropdown">
                <input
                  type="date"
                  className="period-input"
                  {...register("test_starttime_YYYYMMDD", { required: true })}
                />
                <Select
                  options={hourOptions}
                  refs={{
                    ...register("test_starttime_HH", { required: true }),
                  }}
                />
                <Select
                  options={minuteOptions}
                  refs={{
                    ...register("test_starttime_mm", { required: true }),
                  }}
                />
              </div>

              <span className="date-period end-period">종료일시</span>

              <div className="dropdown period-dropdown">
                <input
                  type="date"
                  className="period-input"
                  {...register("test_endtime_YYYYMMDD", { required: true })}
                />
                <Select
                  options={hourOptions}
                  refs={{
                    ...register("test_endtime_HH", { required: true }),
                  }}
                />
                <Select
                  options={minuteOptions}
                  refs={{
                    ...register("test_endtime_mm", { required: true }),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="plus-box">
            <p className="plus-title">로고등록</p>
            <label htmlFor="uploadBtn" className="upload-btn file-btn">
              파일선택
            </label>
            <input
              type="text"
              className="fileName"
              id="fileName"
              placeholder={filename}
              disabled="disabled"
            />
            <input
              type="file"
              id="uploadBtn"
              name="uploadBtn"
              className="uploadBtn"
              style={{ display: "none" }}
              onChange={(e) => {
                setFilename(e.target.files[0].name);
              }}
            />
          </div>
          <div className="plus-box">
            <p className="plus-title">접수 URL</p>
            <input
              type="text"
              className="plus-title-input"
              style={{ width: "675px" }}
              disabled={true}
              defaultValue={receiptUrl}
            />
            <button
              type="button"
              className="btn-custom b-btn url-copy"
              onClick={() => {
                navigator.clipboard.writeText(receiptUrl).then(() => {
                  alert("복사되었습니다.");
                });
              }}
            >
              복사하기
            </button>
          </div>
          <div className="plus-box">
            <p className="plus-title">응시 URL</p>
            <input
              type="text"
              className="plus-title-input"
              style={{ width: "675px" }}
              disabled={true}
              defaultValue={applyUrl}
            />
            <button
              type="button"
              className="btn-custom b-btn url-copy"
              onClick={() => {
                navigator.clipboard.writeText(applyUrl).then(() => {
                  alert("복사되었습니다.");
                });
              }}
            >
              복사하기
            </button>
          </div>
          <div className="plus-box">
            <span className="plus-title">시험 유형</span>
            <Select
              value={ExamResultList?.data["language"]}
              options={speakLanguageOption}
              refs={{
                ...register("room_type"),
              }}
            />
          </div>
          {/* <div className="plus-box">
            <span className="plus-title">문제 언어</span>
            <Select
              options={questionOption}
              refs={{
                ...register("language"),
              }}
            />
          </div> */}
        </div>
        <div>
          <button
            type="button"
            className="modal-btn modal-close-btn"
            data-bs-toggle="modal"
            data-bs-target="#delete"
          >
            삭제
          </button>
          <button
            type="submit"
            className="modal-btn modal-save-btn"
            onClick={() => {}}
          >
            저장
          </button>
        </div>
      </form>

      {/* {exerciseQuestion(getExerciseList, setExerciseList, isTestRoomSn)}
      <div className="roomtable-content7-sec">
        <div>
          <p style={{ fontWeight: 700, marginBottom: "1.125rem" }}>
            음성안내 파일
          </p>
        </div>
        <div
          className="tableFixHead table-responsive"
          style={{ maxHeight: 1000 }}
        >
          <div className="table-responsive">
            <table className="roomtable-content7-2 modify-table">
              <tbody>
                <tr>
                  <th>No.</th>
                  <th>구분</th>
                  <th>음성파일 듣기</th>
                  <th>재생여부</th>
                  <th>작업</th>
                </tr>
                <VoiceGuide
                  getGuidanceList={getGuidanceList?.data?.data}
                  setGuidanceList={setGuidanceList}
                  isTestRoomSn={isTestRoomSn}
                  setVoiceGuideAudioNumber={setVoiceGuideAudioNumber}
                />
              </tbody>
            </table>
          </div>
        </div>
        <div className="text-align-center">
          <p className="table-comment" style={{ marginottom: 0 }}>
            채용면접실 개설 시 기본으로 적용되는 음성안내 메시지 입니다. 각
            채용면접실 '설정'에서 재생여부 등을 관리할 수 있습니다.
            <br />
            '수정' 아이콘 선택 후 음성파일(.mp3)을 등록하고 '완료'를 선택하면 그
            시점부터 개설되는 채용면접실에 적용됩니다.
          </p>
        </div>
      </div> */}
    </div>
  );
};

export default Settings;
